// extracted by mini-css-extract-plugin
export default {"corporateAccountsTable":"GzBPEMx_ce3OJ2Y5y5OG"};